export default "__VITE_ASSET__DvCBNte2__"